
import ContentPage from "components/ContentPage";
import ListDetailManager from "components/list/ListDetailManager";
import { APP_KEYS } from "constants";
import { routeObjects } from "mappings/RouteObjects";
const ADMIN_LAYOUT = "/admin";
const OBJ_VISIBLE_KEY = (obj) => `is_${obj}_visible`

const createRoute = (route) => {
    const appVisibility = Object.values(APP_KEYS).reduce((acc, key) => {
        if (route[key] !== undefined) {
            acc[key] = route[key];
        }
        return acc;
    }, {});

    return { 
        ...appVisibility,
        path: `/${route.obj}`,
        name: route.obj,
        icon: `tim-icons ${route.icon}`,
        component: <ContentPage component={route.component || ListDetailManager} />,
        key: OBJ_VISIBLE_KEY(route.obj),
        ...(!route.component && {
            children: [
                { path: "", component: <ContentPage component={ListDetailManager} /> },
                { path: ":id/*", component: <ContentPage component={ListDetailManager} /> },
                { path: ":id/uploads/:uploadId/*", component: <ContentPage component={ListDetailManager} /> },
            ]
        }),
        layout: ADMIN_LAYOUT,
        rtlName: "الرموز", // Default RTL name
    };
}

const routes = routeObjects.filter(route => !route.parent).map(createRoute);

export default routes;